// app/javascript/modules/admissoes/reservista.js

export function initReservista($form, h) {
  const { hide, show, parseDateSmart, calcAge } = h
  const ns = ".admissaoReservista"

  function verificarCondicoesReservista() {
    const sexo = $form.find("#params_sexo").val()
    const dn = parseDateSmart($form.find("#params_data_nascimento").val())

    // upload do certificado reservista
    const $uploadReservista = $form.find(".params_movimentacoes_pessoal_certificado_reservista")
    // campo de texto codigo_reservista
    const $textoReservista = $form.find(".params_codigo_reservista")

    if (!sexo || sexo !== "M") {
      // Mulher ou sexo nao selecionado: esconde tudo
      hide($uploadReservista)
      hide($textoReservista)
      return
    }

    // Homem: verifica idade (18-42)
    if (dn) {
      const idade = calcAge(dn)
      if (idade !== null && idade >= 18 && idade <= 42) {
        show($uploadReservista)
        show($textoReservista)
      } else {
        hide($uploadReservista)
        hide($textoReservista)
      }
    } else {
      // Homem sem data de nascimento: mostra por precaucao
      show($uploadReservista)
      show($textoReservista)
    }
  }

  $form.off(ns)
  $form.on(`change${ns}`, "#params_sexo, #params_data_nascimento", verificarCondicoesReservista)

  return {
    apply() { verificarCondicoesReservista() },
    destroy() { $form.off(ns) }
  }
}
